var React = require('react');

function Tooltip (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#999","fillRule":"evenodd","d":"M16 8c0 4.414-3.586 8-8 8s-8-3.586-8-8 3.586-8 8-8 8 3.586 8 8ZM8.913 4.211v-.947a.437.437 0 0 0-.44-.44h-.947a.437.437 0 0 0-.44.44v.947c0 .237.204.44.44.44h.948c.236 0 .44-.203.44-.44Zm1.709 8.677v-.88a.448.448 0 0 0-.44-.44h-1.32V6.073a.433.433 0 0 0-.422-.44H5.818a.448.448 0 0 0-.44.44v.862c0 .254.203.44.44.44h1.303v4.195H5.818a.448.448 0 0 0-.44.44v.879c0 .237.203.423.44.423h4.364c.237 0 .44-.186.44-.423Z","clipRule":"evenodd"}));
}

Tooltip.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Tooltip;

Tooltip.default = Tooltip;
